// @ts-nocheck
import useProductContext from "@store/Framework/Store/Data/Products/ProductsHooks/useProductContext";
import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import { ProductContextModel } from "@insite/client-framework/Components/ProductContext";
import ProductImage, { ProductImageStyles } from "@store/Overrides/Components/ProductImage";
import React from "react";
import { css } from "styled-components";

export type EasingFunction =
    | "ease"
    | "ease-in"
    | "ease-out"
    | "ease-in-out"
    | "linear"
    | "step-start"
    | "step-end"
    | (string & {});

const productImageWithHoverStyles: ProductImageStyles = {};

const getImageStyles = (
    opacity: number,
    styles: ProductImageStyles,
    transitionDuration: number,
    transitionTimingFunction: EasingFunction,
): ProductImageStyles => ({
    ...styles,
    wrapper: {
        css: css`
            ${styles.wrapper?.css}
            opacity: ${opacity};
            transition: opacity ${transitionDuration}ms ${transitionTimingFunction};
            position: ${opacity ? "relative" : "absolute"};
            top: 0;
            left: 0;
        `,
    },
});

interface ProductImageWithHoverProps {
    extendedStyles?: ProductImageStyles;
    size?: "small" | "medium" | "large";
    transitionDuration?: number;
    transitionTimingFunction?: EasingFunction;
    hoverImageProduct: ProductContextModel;
    isHovered: boolean;
    enableImageHover: boolean;
    innerOnClick?: (event: React.MouseEvent<HTMLAnchorElement>) => void;
}

const ProductImageWithHover: React.FC<ProductImageWithHoverProps> = ({
    hoverImageProduct,
    isHovered,
    size = "medium",
    transitionDuration = 500,
    transitionTimingFunction = "ease-in-out",
    extendedStyles,
    enableImageHover,
    innerOnClick,
}) => {
    const productContext = useProductContext();
    const styles = mergeToNew(productImageWithHoverStyles, extendedStyles);

    const defaultImageOpacity = isHovered ? 0 : 1;
    const hoverImageOpacity = isHovered ? 1 : 0;

    const defaultImageStyles = React.useMemo(
        () => getImageStyles(defaultImageOpacity, styles, transitionDuration, transitionTimingFunction),
        [defaultImageOpacity, styles, transitionDuration, transitionTimingFunction],
    );

    const hoverImageStyles = React.useMemo(
        () => getImageStyles(hoverImageOpacity, styles, transitionDuration, transitionTimingFunction),
        [hoverImageOpacity, styles, transitionDuration, transitionTimingFunction],
    );
    if (!enableImageHover) {
        return (
            <ProductImage onClick={innerOnClick} product={productContext} size={size} extendedStyles={extendedStyles} />
        );
    }
    return (
        <>
            <ProductImage
                product={productContext}
                size={size}
                onClick={innerOnClick}
                extendedStyles={defaultImageStyles}
                aria-hidden={isHovered}
            />
            <ProductImage
                product={hoverImageProduct}
                size={size}
                onClick={innerOnClick}
                extendedStyles={hoverImageStyles}
                aria-hidden={!isHovered}
            />
        </>
    );
};

export default ProductImageWithHover;
